// App version from package.json (single source of truth)
import pkg from '../../package.json' with { type: "json" };
export const APP_VERSION = pkg.version;

// API configuration
// In production, set API_URL environment variable
// In development, defaults to local server
// Use ?? so empty string (for relative URLs in production) isn't treated as falsy
export const API_BASE_URL = process.env.API_URL ?? 'http://127.0.0.1:3000';

// Player URL
export const PLAYER_BASE_URL = process.env.PLAYER_URL || 'https://player.invintus.com';

// Control Center URL
export const CC_BASE_URL = 'https://controlcenter.invintusmedia.com';

// Scaledrone WebSocket
export const SCALEDRONE_CHANNEL_ID = process.env.SCALEDRONE_CHANNEL_ID || '';
export const SCALEDRONE_TEST_CLIENT_ID = process.env.SCALEDRONE_TEST_CLIENT_ID || '';
export const SCALEDRONE_TEST_MODE_MAX_CLIENTS = parseInt(process.env.SCALEDRONE_TEST_MODE_MAX_CLIENTS || '0', 10);